export const extractShopifyHandle = (url) => {
    return url.split("/products/")[1]?.split("/")[0] || null;
}